import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { Talent, listTalents } from "./talentAPI";

type Entities = {
  [key: string]: any;
};

export type SliceState = {
  ids: [];
  entities: Entities;
  cursor: string[] | null;
  status: "idle" | "pending" | "succeeded" | "failed";
  error?: string;
};

const talentsListAdapter = createEntityAdapter<Talent>({
  sortComparer: (a, b) => a.account.lastName.localeCompare(b.account.lastName),
});

export const fetchTalentsList = createAsyncThunk<
  Talent[],
  {},
  { state: RootState }
>("talentsList/fetchTalentsList", async (_, { requestId }) => {
  const res = await listTalents({ requestId });
  return res.data;
});

export const talentsListSlice = createSlice({
  name: "talentsList",
  initialState: talentsListAdapter.getInitialState({
    status: "idle",
  }) as SliceState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTalentsList.fulfilled, (state, action) => {
      talentsListAdapter.setAll(state, action.payload);
      state.status = "succeeded";
    });
    builder.addCase(fetchTalentsList.pending, (state) => {
      state.status = "pending";
    });
    builder.addCase(fetchTalentsList.rejected, (state) => {
      state.status = "failed";
    });
  },
});

export const talentsListReducer = talentsListSlice.reducer;
